import { useEffect } from "react";

/**
 * Prisili light-mode za javne strani (landing, register, demo, login).
 * Ob unmountu obnovi prejšnjo temo iz localStorage (`theme=dark|light`).
 * Marketing / javni content mora biti dosleden ne glede na sistemske
 * nastavitve obiskovalca (dark mode CSS spremenljivke uporabljajo svetlo
 * zelene odtenke, ki niso primerni za landing hero/CTA design).
 */
export const useForceLightMode = () => {
  useEffect(() => {
    const root = document.documentElement;
    const wasDark = root.classList.contains("dark");
    if (wasDark) {
      root.classList.remove("dark");
      root.dataset.forcedLight = "1";
    }
    return () => {
      if (root.dataset.forcedLight === "1") {
        root.classList.add("dark");
        delete root.dataset.forcedLight;
      }
    };
  }, []);
};

export default useForceLightMode;
